{
  "schema": "ft.xz3d.room-type-catalog.v1",
  "revision": "room-type-catalog-v1-20260910-ambience",
  "notes": "DAFT3D S2. Tokens per docs/DAFT3D_FAMILY_VOCABULARY.md: ids are <theme>-<room_type> (one hyphen, snake_case halves); grammar families name archetypes (open set, registered by the S3 tagging preset) or, for the cave theme, the legacy dressing families the pilot fixture still tags. Zones are canonical (corner | wall_band | center). Capability names are code names: objects owns every furniture/clutter section, lights owns the light plan, loot owns container contents (S9). A recipe can only narrow a preset's capabilities. S13 (2026-09-07): the cave grammars name the kit archetypes (fungus_cluster, bedroll, crate, sack, altar, candle, brazier, campfire) and honest standee synonyms (stalagmite, boulder, egg_nest, mudpit, eggshell, pillar_stone, wall_stone, rubble); the fixture-era families with no catalog item (stone-cluster, fungal-ring, wet-rock, mineral-shelf, pool-edge-growth, nest-scrape, warm-mud-vent, shell-fragments, offering-stone, broken-column, carved-rubble, wall-stones, candle-cluster) are retired as Codex Astra asset orders, never faked. Second pass: rug → rug_large (the kit names Rug, Large / Rug, Huge); every other line already carried a resolvable alternative.",
  "themes": [
    {
      "id": "cave",
      "label": "Cave",
      "preset": "wet-cave-interior",
      "locationTypeIds": [
        "4EC766F1-258D-0BED-F7F6-5C51307F688C",
        "381EED2E-EECF-F30B-53C9-BB6BD121A652"
      ]
    },
    {
      "id": "alchemists_laboratory",
      "label": "Alchemists' Laboratory",
      "preset": "old-stone-dungeon-interior",
      "locationTypeIds": [
        "EB59D8AE-9995-800A-4696-3254B1FD6A13",
        "B71C82DA-CC53-C15E-9DC9-052AF2734E5F"
      ]
    },
    {
      "id": "crypt",
      "label": "Crypt",
      "preset": "old-stone-dungeon-interior",
      "locationTypeIds": [
        "AEFB6B35-A12E-7BAD-1D40-67A8169176E7",
        "031CE1BD-22BF-7A83-3B12-EDC30FEB8907"
      ]
    },
    {
      "id": "tavern",
      "label": "Tavern",
      "preset": "old-stone-dungeon-interior",
      "locationTypeIds": [
        "9ACC3705-F8A5-1ED2-22BA-308C52D94DEF",
        "E75F440A-B675-0C34-AEDD-568FDAD06675"
      ]
    }
  ],
  "entries": [
    {
      "id": "cave-natural_chamber",
      "music": { "bucket": "mysterious" },
      "ambience": { "mode": "custom", "audioId": "0B305DC6-57E4-B7E6-FBFA-FA068CCDECDC", "wind": "off" },
      "theme": "cave",
      "label": "Natural Chamber",
      "preset": "wet-cave-interior",
      "aliases": [
        "natural-chamber",
        "natural_chamber"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [],
        "wall_band": [
          {
            "family": "stalagmite",
            "min": 1,
            "max": 4,
            "zone": "wall_band"
          },
          {
            "family": "boulder",
            "max": 3,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "fungus_cluster",
            "max": 2
          }
        ],
        "clutter": [
          {
            "family": "rubble",
            "max": 4
          }
        ],
        "lights": {
          "family": "brazier|campfire",
          "perFt2": 0,
          "min": 0,
          "max": 3
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": null
      },
      "containers": {
        "fillPools": [],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "cave beasts, fungi"
      },
      "toggles": {
        "walls": true,
        "lights": false,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": false,
        "roofs": true
      }
    },
    {
      "id": "cave-wet_grotto",
      "music": { "bucket": "mysterious" },
      "theme": "cave",
      "label": "Wet Grotto",
      "preset": "wet-cave-interior",
      "aliases": [
        "wet-grotto",
        "wet_grotto"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "boulder",
            "min": 0,
            "max": 1,
            "zone": "center"
          }
        ],
        "wall_band": [
          {
            "family": "stalagmite",
            "min": 1,
            "max": 4
          }
        ],
        "center": [
          {
            "family": "fungus_cluster",
            "max": 2
          }
        ],
        "clutter": [],
        "lights": {
          "family": "brazier",
          "perFt2": 0,
          "min": 0,
          "max": 3
        }
      },
      "density": {
        "default": 3
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": "scanslibrary_yn2us4"
      },
      "containers": {
        "fillPools": [],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "cockatrice, amphibians"
      },
      "toggles": {
        "walls": true,
        "lights": false,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": false,
        "roofs": true
      }
    },
    {
      "id": "cave-hatchery",
      "music": { "bucket": "scary_medium" },
      "theme": "cave",
      "label": "Hatchery",
      "preset": "wet-cave-interior",
      "aliases": [
        "hatchery"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "egg_nest",
            "min": 1,
            "max": 3,
            "zone": "center"
          }
        ],
        "wall_band": [
          {
            "family": "stalagmite",
            "max": 3
          }
        ],
        "center": [
          {
            "family": "mudpit",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "eggshell",
            "max": 4
          }
        ],
        "lights": {
          "family": "brazier",
          "perFt2": 0,
          "min": 0,
          "max": 3
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": null
      },
      "containers": {
        "fillPools": [],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "brood mother, hatchlings"
      },
      "toggles": {
        "walls": true,
        "lights": false,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": false,
        "roofs": true
      }
    },
    {
      "id": "cave-occupied_cave",
      "music": { "bucket": "scary_slow" },
      "theme": "cave",
      "label": "Occupied Cave",
      "preset": "wet-cave-interior",
      "aliases": [
        "occupied-cave",
        "occupied_cave"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "bedroll",
            "min": 1,
            "max": 4,
            "zone": "wall_band"
          }
        ],
        "wall_band": [
          {
            "family": "crate",
            "max": 2,
            "zone": "corner"
          },
          {
            "family": "sack",
            "max": 2
          }
        ],
        "center": [],
        "clutter": [
          {
            "family": "rubble",
            "max": 2
          }
        ],
        "lights": {
          "family": "brazier|campfire",
          "perFt2": 0.003,
          "min": 1,
          "max": 3
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "camp_supplies"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "bandits, goblins, a hermit"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "cave-ruined_shrine",
      "music": { "bucket": "desecration" },
      "theme": "cave",
      "label": "Ruined Shrine",
      "preset": "wet-cave-interior",
      "aliases": [
        "ruined-shrine",
        "ruined_shrine"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "altar",
            "min": 1,
            "max": 1,
            "zone": "center",
            "facing": "room"
          }
        ],
        "wall_band": [
          {
            "family": "pillar_stone",
            "max": 4
          }
        ],
        "center": [],
        "clutter": [
          {
            "family": "rubble",
            "max": 4
          }
        ],
        "lights": {
          "family": "candle",
          "perFt2": 0.005,
          "min": 1,
          "max": 3
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": "scanslibrary_yn2us4"
      },
      "containers": {
        "fillPools": [
          "offerings"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "cultists, a forgotten guardian"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "cave-connector",
      "theme": "cave",
      "label": "Passage",
      "preset": "wet-cave-interior",
      "aliases": [
        "connector"
      ],
      "lane": "inventory",
      "grammar": {
        "anchors": [],
        "wall_band": [
          {
            "family": "wall_stone",
            "max": 3
          }
        ],
        "center": [],
        "clutter": [
          {
            "family": "rubble",
            "max": 2
          }
        ],
        "lights": {
          "family": "brazier",
          "perFt2": 0,
          "min": 0,
          "max": 3
        }
      },
      "density": {
        "default": 1
      },
      "surfaces": {
        "floor": "scanslibrary_hzbjt3",
        "wall": "scanslibrary_mfxw5n",
        "accent": null
      },
      "containers": {
        "fillPools": [],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": ""
      },
      "toggles": {
        "walls": true,
        "lights": false,
        "tiles": true,
        "doors": false,
        "windows": false,
        "objects": true,
        "loot": false,
        "roofs": true
      }
    },
    {
      "id": "alchemists_laboratory-laboratory",
      "music": { "bucket": "weird" },
      "theme": "alchemists_laboratory",
      "label": "Laboratory",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "workbench|countertop|desk",
            "min": 1,
            "max": 2,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "shelf|shelf_double",
            "min": 2,
            "max": 4
          },
          {
            "family": "bookshelf",
            "max": 1
          },
          {
            "family": "curio_cabinet",
            "max": 1,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "table_long",
            "min": 1,
            "max": 1,
            "facing": "along_wall"
          },
          {
            "family": "stool",
            "max": 2,
            "anchorRef": "table_long",
            "facing": "focus"
          }
        ],
        "clutter": [
          {
            "family": "crate",
            "max": 2,
            "zone": "corner"
          },
          {
            "family": "barrel",
            "max": 2,
            "zone": "corner"
          },
          {
            "family": "jar_glass",
            "max": 6
          },
          {
            "family": "tools_alchemy",
            "max": 2
          }
        ],
        "lights": {
          "family": "candelabrum|lantern_hooded|brazier",
          "perFt2": 0.01,
          "min": 2,
          "max": 6
        },
        "hazards": [
          {
            "family": "reagent_spill",
            "max": 1,
            "optional": true
          }
        ]
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "alchemy_reagents",
          "glassware",
          "notes"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "alchemist, apprentice, homunculus"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "alchemists_laboratory-library",
      "music": { "bucket": "mystery_solving" },
      "theme": "alchemists_laboratory",
      "label": "Library",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "bookshelf_tall|bookshelf|bookshelf_wide",
            "min": 2,
            "max": 6,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          },
          {
            "family": "desk",
            "min": 1,
            "max": 1,
            "zone": "wall_band",
            "facing": "room"
          }
        ],
        "wall_band": [],
        "center": [
          {
            "family": "table_long",
            "max": 1,
            "facing": "along_wall"
          },
          {
            "family": "chair_luxury|chair",
            "max": 4,
            "anchorRef": "table_long",
            "facing": "focus"
          },
          {
            "family": "podium",
            "max": 1
          },
          {
            "family": "rug_large",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "book",
            "max": 6
          },
          {
            "family": "scroll_case",
            "max": 2
          }
        ],
        "lights": {
          "family": "chandelier|candelabrum|candelabrum_wall",
          "perFt2": 0.008,
          "min": 2,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "books",
          "scrolls",
          "skill_books"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "scholar, librarian, bound spirit"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": true,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "alchemists_laboratory-storage_room",
      "theme": "alchemists_laboratory",
      "label": "Storage Room",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "shelf_double|cupboard",
            "min": 1,
            "max": 3,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "crate",
            "min": 1,
            "max": 4,
            "zone": "corner"
          },
          {
            "family": "barrel",
            "min": 1,
            "max": 4
          },
          {
            "family": "box",
            "max": 3
          },
          {
            "family": "basket",
            "max": 2
          },
          {
            "family": "sack",
            "max": 3
          }
        ],
        "center": [
          {
            "family": "chest|coffer",
            "max": 1
          },
          {
            "family": "wardrobe",
            "max": 1,
            "zone": "wall_band"
          }
        ],
        "clutter": [
          {
            "family": "jar_glass",
            "max": 4
          }
        ],
        "lights": {
          "family": "torch|lantern_hooded",
          "perFt2": 0.006,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "reagent_stock",
          "trade_goods",
          "rations"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "rats, a mimic"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "alchemists_laboratory-dissection_room",
      "music": { "bucket": "scary_slow" },
      "theme": "alchemists_laboratory",
      "label": "Dissection Room",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "slab_table|table_long",
            "min": 1,
            "max": 1,
            "zone": "center",
            "facing": "along_wall",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "shelf",
            "min": 1,
            "max": 3
          },
          {
            "family": "cabinet_low",
            "max": 2
          }
        ],
        "center": [
          {
            "family": "corpse|skeleton",
            "max": 1,
            "anchorRef": "slab_table"
          },
          {
            "family": "bathtub",
            "max": 1,
            "zone": "corner"
          }
        ],
        "clutter": [
          {
            "family": "jar_glass",
            "max": 6
          },
          {
            "family": "bucket",
            "max": 2
          },
          {
            "family": "bones",
            "max": 3
          }
        ],
        "lights": {
          "family": "candelabrum|lantern_bullseye",
          "perFt2": 0.01,
          "min": 2,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "specimens",
          "monster_bits",
          "surgical_tools"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "anatomist, flesh golem, ghoul"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "alchemists_laboratory-blast_room",
      "music": { "bucket": "weird" },
      "theme": "alchemists_laboratory",
      "label": "Blast Room",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "wall_stone",
            "min": 1,
            "max": 2,
            "zone": "center",
            "required": false
          }
        ],
        "wall_band": [
          {
            "family": "crate",
            "max": 3,
            "zone": "corner"
          },
          {
            "family": "barrel",
            "max": 2,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "cannonball_holder",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "rubble",
            "max": 4
          },
          {
            "family": "bucket",
            "max": 1
          }
        ],
        "lights": {
          "family": "brazier",
          "perFt2": 0.005,
          "min": 1,
          "max": 6
        },
        "hazards": [
          {
            "family": "scorch",
            "max": 2,
            "optional": true
          },
          {
            "family": "explosive",
            "max": 2,
            "optional": true
          }
        ]
      },
      "density": {
        "default": 1
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "blasting_powder",
          "fuses"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "engineer, salamander"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "crypt-burial_chamber",
      "music": { "bucket": "scary_slow", "combatBucket": "battle_scary" },
      "ambience": { "mode": "custom", "audioId": "A328EBC6-EA8C-C260-8880-0FEC89C30BBD", "wind": "off" },
      "theme": "crypt",
      "label": "Burial Chamber",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "slab_table|altar",
            "min": 1,
            "max": 2,
            "zone": "center",
            "facing": "along_wall",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "statue",
            "max": 2,
            "zone": "corner",
            "facing": "room"
          },
          {
            "family": "coffer|chest",
            "max": 1
          }
        ],
        "center": [
          {
            "family": "skeleton|corpse",
            "max": 1,
            "anchorRef": "slab_table"
          }
        ],
        "clutter": [
          {
            "family": "bones",
            "max": 4
          },
          {
            "family": "rubble",
            "max": 2
          }
        ],
        "lights": {
          "family": "candelabrum|brazier",
          "perFt2": 0.006,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 1
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "grave_goods",
          "coins"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "wight, skeletons, a mourning ghost"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "crypt-ossuary",
      "music": { "bucket": "scary_slow", "combatBucket": "battle_scary" },
      "theme": "crypt",
      "label": "Ossuary",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "shelf|shelf_double",
            "min": 2,
            "max": 6,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [],
        "center": [
          {
            "family": "podium",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "bones",
            "max": 8
          },
          {
            "family": "trophy_skull",
            "max": 4
          }
        ],
        "lights": {
          "family": "candle|candelabrum",
          "perFt2": 0.008,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "bones",
          "relics"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "bone naga, swarms"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "crypt-chapel",
      "music": { "bucket": "desecration", "combatBucket": "battle_scary" },
      "theme": "crypt",
      "label": "Chapel",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "altar",
            "min": 1,
            "max": 1,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "statue",
            "max": 2,
            "zone": "corner",
            "facing": "room"
          }
        ],
        "center": [
          {
            "family": "bench",
            "min": 1,
            "max": 4,
            "anchorRef": "altar",
            "facing": "focus"
          },
          {
            "family": "podium",
            "max": 1,
            "anchorRef": "altar"
          },
          {
            "family": "rug_large",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "book",
            "max": 1
          }
        ],
        "lights": {
          "family": "candelabrum|chandelier|candle|candelabrum_wall",
          "perFt2": 0.01,
          "min": 2,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "offerings",
          "holy_texts"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": "death priest, acolytes"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": true,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "crypt-catacomb_passage",
      "music": { "bucket": "scary_slow", "combatBucket": "battle_scary" },
      "theme": "crypt",
      "label": "Catacomb Passage",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [],
        "wall_band": [
          {
            "family": "shelf",
            "max": 4,
            "facing": "room"
          },
          {
            "family": "statue",
            "max": 1,
            "zone": "corner"
          }
        ],
        "center": [],
        "clutter": [
          {
            "family": "bones",
            "max": 4
          },
          {
            "family": "rubble",
            "max": 2
          }
        ],
        "lights": {
          "family": "torch_wall|candle",
          "perFt2": 0.005,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 1
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "bones"
        ],
        "emptyIsAuthored": true
      },
      "occupants": {
        "hint": ""
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": false,
        "roofs": true
      }
    },
    {
      "id": "tavern-common_room",
      "music": { "bucket": "taverns" },
      "ambience": { "mode": "custom", "audioId": "0457921F-C2B9-8566-A9B7-AF70201047DF", "wind": "off" },
      "theme": "tavern",
      "label": "Common Room",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "countertop|table_long",
            "min": 1,
            "max": 1,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "shelf|cupboard",
            "min": 1,
            "max": 3
          },
          {
            "family": "barrel",
            "max": 3,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "table_round|table_small",
            "min": 2,
            "max": 6
          },
          {
            "family": "chair|stool",
            "min": 4,
            "max": 12,
            "anchorRef": "table_round",
            "facing": "focus"
          },
          {
            "family": "bench",
            "max": 2,
            "facing": "along_wall"
          }
        ],
        "clutter": [
          {
            "family": "bottle",
            "max": 6
          },
          {
            "family": "book",
            "max": 1
          }
        ],
        "lights": {
          "family": "chandelier|candelabrum|lantern",
          "perFt2": 0.01,
          "min": 2,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "drinks",
          "food",
          "coins"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "innkeeper, patrons, a bard"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": true,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "tavern-kitchen",
      "music": { "bucket": "working" },
      "theme": "tavern",
      "label": "Kitchen",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "countertop|workbench",
            "min": 1,
            "max": 3,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "shelf|cupboard",
            "min": 1,
            "max": 3
          },
          {
            "family": "barrel",
            "max": 2,
            "zone": "corner"
          },
          {
            "family": "crate",
            "max": 2,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "table_small|table_long",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "bucket",
            "max": 2
          },
          {
            "family": "bottle",
            "max": 4
          },
          {
            "family": "jar_glass",
            "max": 3
          }
        ],
        "lights": {
          "family": "campfire|brazier|lantern",
          "perFt2": 0.006,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "food",
          "cookware"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "cook, scullion"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": true,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "tavern-cellar",
      "theme": "tavern",
      "label": "Cellar",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "barrel",
            "min": 2,
            "max": 8,
            "zone": "wall_band",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "shelf|shelf_double",
            "max": 3
          },
          {
            "family": "crate",
            "max": 4,
            "zone": "corner"
          }
        ],
        "center": [
          {
            "family": "table_small",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "bottle",
            "max": 8
          },
          {
            "family": "sack",
            "max": 3
          }
        ],
        "lights": {
          "family": "lantern_hooded|torch",
          "perFt2": 0.004,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 2
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "drinks",
          "rations",
          "smuggled_goods"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "rats, a smuggler"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": false,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    },
    {
      "id": "tavern-guest_room",
      "music": { "bucket": "happy_slow" },
      "theme": "tavern",
      "label": "Guest Room",
      "preset": "old-stone-dungeon-interior",
      "aliases": [],
      "lane": "inventory",
      "grammar": {
        "anchors": [
          {
            "family": "bed_single|bed_double",
            "min": 1,
            "max": 2,
            "zone": "wall_band",
            "facing": "room",
            "required": true
          }
        ],
        "wall_band": [
          {
            "family": "wardrobe|cabinet_tall",
            "max": 1,
            "zone": "corner"
          },
          {
            "family": "trunk|chest",
            "max": 1
          }
        ],
        "center": [
          {
            "family": "table_small",
            "max": 1
          },
          {
            "family": "chair|stool",
            "max": 2,
            "anchorRef": "table_small",
            "facing": "focus"
          },
          {
            "family": "rug_large",
            "max": 1
          }
        ],
        "clutter": [
          {
            "family": "bottle",
            "max": 1
          },
          {
            "family": "book",
            "max": 1
          }
        ],
        "lights": {
          "family": "candle|lantern",
          "perFt2": 0.006,
          "min": 1,
          "max": 6
        }
      },
      "density": {
        "default": 1
      },
      "surfaces": {
        "floor": "scanslibrary_pe9d59",
        "wall": "scanslibrary_gerq5c",
        "accent": null
      },
      "containers": {
        "fillPools": [
          "personal_effects",
          "coins"
        ],
        "emptyIsAuthored": false
      },
      "occupants": {
        "hint": "a guest, a thief"
      },
      "toggles": {
        "walls": true,
        "lights": true,
        "tiles": true,
        "doors": true,
        "windows": true,
        "objects": true,
        "loot": true,
        "roofs": true
      }
    }
  ]
}
